import HTTPService from '@/services/http_service.js'

export default class PacienteService extends HTTPService {
    resource = 'importacao'

    register (responseFunctions, data) {
        this.jsonRequest(responseFunctions, 'POST', this.resource, data)
    }
  
} 